import { constructEnum } from '@/lib/enum';

export default constructEnum('ProductItemDisplayField', {
  PRODUCT_DETAIL: 1,
  CATEGORY: 2,
  REVIEW_SUMMARY: 4,
  REVIEWS: 8
});
